import { DeliveryAddress, DeliveryAddressInput } from '../../types/api';
import { PIN_CODE_PATTERN } from '../../lib/constants';

export const emptyAddress: DeliveryAddressInput = {
  recipient_name: '',
  phone_number: '',
  address_line_1: '',
  address_line_2: null,
  city: '',
  state: '',
  postal_code: '',
  country: 'IN',
};
/** The editable fields of a saved address. */
export function toAddressInput({ id, is_default, ...input }: DeliveryAddress): DeliveryAddressInput {
  return input;
}
interface Props {
  readonly value: DeliveryAddressInput;
  readonly disabled: boolean;
  readonly onChange: (value: DeliveryAddressInput) => void;
}
export default function DeliveryAddressForm({ value, disabled, onChange }: Props) {
  const fields = [
    ['recipient_name', 'Recipient name', 'name', 100],
    ['phone_number', 'Delivery mobile number (India)', 'tel', 32],
    ['address_line_1', 'Address line 1', 'address-line1', 200],
    ['address_line_2', 'Address line 2 (optional)', 'address-line2', 200],
    ['city', 'City', 'address-level2', 100],
    ['state', 'State', 'address-level1', 100],
    ['postal_code', 'PIN code', 'postal-code', 6],
  ] as const;
  return (
    <fieldset className="address-form" disabled={disabled}>
      <legend>Delivery address</legend>
      {fields.map(([key, label, autoComplete, maxLength]) => (
        <label key={key}>
          {label}
          <input
            value={value[key] ?? ''}
            autoComplete={autoComplete}
            maxLength={maxLength}
            type={key === 'phone_number' ? 'tel' : 'text'}
            inputMode={key === 'postal_code' ? 'numeric' : undefined}
            pattern={key === 'postal_code' ? PIN_CODE_PATTERN : undefined}
            required={key !== 'address_line_2'}
            onChange={(event) => onChange({ ...value, [key]: event.target.value })}
          />
        </label>
      ))}
      <p>Country: India</p>
    </fieldset>
  );
}
